var map = {
	"./agrotech.png": "316e",
	"./belvizelvezetes_tervezes_es_kiviteles.png": "4720",
	"./digitalis_atallas.png": "1dd1",
	"./digitalis_farm.png": "72b8",
	"./digitalis_farm_adatbazis.png": "df80",
	"./dron_felvetelek.png": "a6d2",
	"./elorejelzes_novenyvedelem.png": "28d9",
	"./gep_es_adatgyujtes_beallitas.png": "f0dd",
	"./gepuzemeltetesi_analizis.png": "e63e",
	"./gepuzemeltetesi_elorejelzes_es_adat_elemzesek.png": "b62d",
	"./gepuzemeltetesi_szolgaltatasok.png": "477a",
	"./helyspecifikus_szolgaltatasok.png": "9161",
	"./hot_line_segednyujtas.png": "62f7",
	"./mobil_zold_ikon.svg": "e94e",
	"./parner_program.png": "222a",
	"./szaktanacsadas.png": "81a4",
	"./zold_doboz_fehernyil.svg": "71e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f69e";